import LabServiceModel from "@/models/LabServiceModel";
import SubmissionModel from "@/models/lab/SubmissionModel";
import SampleStatusLogModel from "./SampleStatusLogModel";
import SampleStatusLogCollection from "../../collections/lab/SampleStatusLogCollection";
import isNil from 'lodash/isNil'

export default class SampleModel extends LabServiceModel {

  modelName() {
    return 'sample';
  }

  defaults() {
    return {
      id: null,
      pid: null,
      submission_id: null,
      submission: null,
      number: null,
      abbrev: null,
      identifier: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      sample_septic: null,
      sample_soil: null,
      sample_status_logs: [],
      current_sample_status_log: null,
    }
  }

  nullLatLongMutator(val) {
    const num = _.isNull(val) ? null : _.toNumber(val);
    if (_.isFinite(num)) {
      return num.toFixed(6);
    }
    return null;
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      pid: (val) => (this.nullStringMutator(val)),
      submission_id: (val) => (this.nullStringMutator(val)),
      number: (val) => (this.nullStringMutator(val)),
      abbrev: (val) => (this.nullStringMutator(val)),
      identifier: (val) => (this.nullStringMutator(val)),
      type: val => (val ? this.nullStringMutator(val) : undefined),
      feed_type_id: val => (val ? this.nullStringMutator(val) : undefined),
      animal_fed_id: val => (val ? this.nullStringMutator(val) : undefined),
      bore_hole: val => (val ? this.nullStringMutator(val) : undefined),
      texture: val => (val ? this.nullStringMutator(val) : undefined),
      horizon: val => (val ? this.nullStringMutator(val) : undefined),
      usage: val => (val ? this.nullStringMutator(val) : undefined),
      harvest_date: val => (val ? this.nullStringMutator(val) : undefined),
      depth_start: val => (val ? this.nullStringMutator(val) : undefined),
      depth_end: val => (val ? this.nullStringMutator(val) : undefined),

      lat: val => (val ? this.nullLatLongMutator(val) : undefined),
      long: val => (val ? this.nullLatLongMutator(val) : undefined),

      update_reason: val => (val ? this.nullStringMutator(val) : undefined),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getIdentifier() {
    return this.saved(this.getOption('identifier'));
  }

  isNew() {
    return isNil(this.getIdentifier());
  }

  getSubmission() {
    return this.getRelatedModel(SubmissionModel, 'submission');
  }

  getSampleStatusLogs() {
    return this.getRelatedCollection((new SampleStatusLogCollection()), 'sample_status_logs');
  }

  getCurrentSampleStatusLog() {
    return this.getRelatedModel(SampleStatusLogModel, 'current_sample_status_log');
  }

  publicNumber() {
    return this.get('pid')
  }
}
